var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleEffect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.998,
    height: 63.997,
    viewBox: "0 0 63.998 63.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun-svgrepo-com",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 16.001,
    cy: 16.001,
    r: 16.001,
    transform: "translate(16.002 16.004)",
    fill: "#9da1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M12,32a4,4,0,0,0-4-4H4a4,4,0,0,0,0,8H8A4,4,0,0,0,12,32Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M12.2,46.139,9.372,48.972a4,4,0,0,0,5.657,5.656L17.862,51.8A4,4,0,1,0,12.2,46.139Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M32,52a4,4,0,0,0-4,4v4a4,4,0,0,0,8,0l0-4A3.994,3.994,0,0,0,32,52Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M51.8,46.143A4,4,0,1,0,46.145,51.8l2.829,2.828a4,4,0,0,0,5.656-5.656Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M60.006,28,56,28A4,4,0,0,0,56,36h4a4,4,0,0,0,.008-8Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M51.8,17.859l2.828-2.829a4,4,0,0,0-5.652-5.661L46.145,12.2A4,4,0,0,0,51.8,17.859Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M32,11.995A3.988,3.988,0,0,0,36,8V4A4,4,0,0,0,28,4L28.011,8A3.984,3.984,0,0,0,32,11.995Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M12.212,17.855A4,4,0,0,0,17.866,12.2L15.037,9.374a4,4,0,0,0-5.669,5.653Z",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleEffect);
export default __webpack_public_path__ + "static/media/toggle_effect.c6d0f5c5a04e9861f8b9d0f301d6d452.svg";
export { ForwardRef as ReactComponent };